import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _objectWithoutProperties from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
var _excluded = ["billing"],
    _excluded2 = ["billing"];
import { Endpoints } from '../Constants';
import RequestHelper from '../RequestHelper';
import { PaymentProviders } from '../../utils/paymentProviders';
import store from '../../state/store';
/**
 * Walk through the multi-step flow for buying an item. Web version.
 * @param {Object} args
 * @param {String} args.ptype Type of purchase (currency, task, consumable)
 * @param {Number} args.currpkgid The SKU of the purchase
 * @param {String} args.redirecturl Where should we send the user back to after they spend money
 * @param {String} [args.address1] Required if target === star. Main address line
 * @param {String} [args.address2] Required if target === star. Secondary address line
 * @param {String} [args.country] Required if target === star. Country the player lives in
 * @param {String} [args.state] Required if target === star. State the player lives in
 * @param {String} [args.city] Required if target === star. City the player lives in
 * @param {String} [args.zip] Required if target === star. Zipcode of where the player lives
 * @param {String} [args.firstname] First name
 * @param {String} [args.lastname] Last name
 * @param {Number} [args.year] Birth year
 * @param {Number} [args.month] Birth month
 * @param {Number} [args.day] Birth day
 *
 * @param {Object} args.billing Billing object
 * @param {String} args.billing.cc Credit card number
 * @param {String} args.billing.cvv Credit card cvv
 * @param {String} args.billing.expiryMonth expiry month
 * @param {String} args.billing.expiryYear expiry year
 */

export default {
  buyItem: function () {
    var _buyItem = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(args) {
      var billing, rest, provider, response, expiryMonth, newLoc;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              billing = args.billing, rest = _objectWithoutProperties(args, _excluded);
              provider = store.getState().shopList.paymentProvider;
              _context.next = 4;
              return RequestHelper.apiPost({
                endpoint: Endpoints.START_WEB_PURCHASE,
                body: rest,
                logJSON: true
              }, false);

            case 4:
              response = _context.sent['0'];

              if (response.success && provider !== PaymentProviders.EWAY) {
                expiryMonth = billing.expiryMonth.toString().length < 2 ? "0".concat(billing.expiryMonth) : billing.expiryMonth;
                newLoc = "".concat(response.formurl, "?billing-cc-number=").concat(billing.cc, "&billing-cvv=").concat(billing.cvv, "&billing-cc-exp=").concat(expiryMonth).concat(billing.expiryYear);
                window.location = newLoc;
              }

              return _context.abrupt("return", response);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function buyItem(_x) {
      return _buyItem.apply(this, arguments);
    }

    return buyItem;
  }(),
  sendAddressInfo: function () {
    var _sendAddressInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(args) {
      var billing, rest, response;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              billing = args.billing, rest = _objectWithoutProperties(args, _excluded2);
              _context2.next = 3;
              return RequestHelper.apiPost({
                endpoint: Endpoints.START_WEB_PURCHASE,
                body: rest,
                logJSON: true
              }, false);

            case 3:
              response = _context2.sent['0'];
              return _context2.abrupt("return", response);

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function sendAddressInfo(_x2) {
      return _sendAddressInfo.apply(this, arguments);
    }

    return sendAddressInfo;
  }(),
  sendDataToCAMS: function () {
    var _sendDataToCAMS = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(args, formUrl) {
      var billing, expiryMonth, newLoc;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              billing = args.billing;
              expiryMonth = billing.expiryMonth.toString().length < 2 ? "0".concat(billing.expiryMonth) : billing.expiryMonth;
              newLoc = "".concat(formUrl, "?billing-cc-number=").concat(billing.cc, "&billing-cvv=").concat(billing.cvv, "&billing-cc-exp=").concat(expiryMonth).concat(billing.expiryYear);
              window.location = newLoc;
              return _context3.abrupt("return", true);

            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    function sendDataToCAMS(_x3, _x4) {
      return _sendDataToCAMS.apply(this, arguments);
    }

    return sendDataToCAMS;
  }()
};